const FEE_TIRE = [
  [5000, 1],
  [20000, 0.9],
  [100000, 0.8],
  [500000, 0.7],
  [2000000, 0.6],
  [-1, 0.5],
]
export default FEE_TIRE
